// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1aX-L","rightAdornment":"Header_rightAdornment__1LeZ_"};